import { CentsToDollarString } from "../../../../lib/DataFormat";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const PRICE_MAPPING = {
  V2_S_Plan: 540 * 100,
  V2_M_Plan: 900 * 100,
  V2_L_Plan: 1080 * 100,
  V2_S_Plan_Yearly: 540 * 100,
  V2_M_Plan_Yearly: 900 * 100,
  V2_L_Plan_Yearly: 1080 * 100,
};

const SubscriptionKindDialog = ({
  finishSubscriptionKindSelect,
  closeWindow,
  plan,
}) => {
  return (
    <TeambookDialog
      title="Select Type of Subscription"
      open={true}
      onClose={closeWindow}
      withCloseButton
      content={
        <div className="flex" style={{justifyContent: "space-between"}}>
          <div
            aria-label="subscription annual box"
            className="subscription__annual-box"
            onClick={() => finishSubscriptionKindSelect("yearly")}
          >
            <p>Annual</p>
            <p>
              <b>{CentsToDollarString(PRICE_MAPPING[plan.plan_id])}</b>
            </p>
          </div>

          <div
            aria-label="subscription monthly box"
            className="subscription__annual-box"
            onClick={() => finishSubscriptionKindSelect("monthly")}
          >
            <p>Monthly</p>
            <p>
              <b>{CentsToDollarString(plan.price_cents)}</b>
            </p>
          </div>
        </div>
      }
    />
  );
};

SubscriptionKindDialog.propTypes = {
  finishSubscriptionKindSelect: PropTypes.func.isRequired,
  closeWindow: PropTypes.func.isRequired,
  plan: PropTypes.object.isRequired,
};

export default SubscriptionKindDialog;
